/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'gemini/lib/@waca/dashboard-common/dist/core/APIFactory',
	'gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI'
], function(_, APIFactory, PropertiesProviderAPI) {

	const BLACKLISTED_PROPERTIES = [
		'layoutPositioning'
	];

	class TopLevelPropertiesProvider {
		constructor(options) {
			this.dashboardApi = options.dashboardAPI;
			this.content = options.content;
			this.stringResources = this.dashboardApi.getFeature('.StringResources');
			this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			// register self as a properties provider contributing storytelling TopLevelPropertiesProvider properties
			this.content.getFeature('Properties').registerProvider(this.getAPI());
		}

		getAPI() {
			return this._api;
		}

		getPropertyLayoutList(){
			return [{
				id: 'canvas',
				type: 'Section',
				label: this.stringResources.get('sectionName_canvas'),
				position: 1
			}];
		}

		getPropertyList() {
			return this._getBlackListedPropertiesList(BLACKLISTED_PROPERTIES);
		}

		_getBlackListedPropertiesList(list) {
			return list.map(propertyName => {
				return {
					id: propertyName,
					getPropertyValue: () => {},
					editor: {
						hidden: true
					}
				};
			});
		}
	}

	return TopLevelPropertiesProvider;

});
